<template>
  <v-container>
    <!-- Nuevo análisis -->
    <v-row class="mb-6 seccion seccion-0" no-gutters>
      <v-col cols="12" lg="8">
        <v-card class="pa-0 mx-2" outlined tile>
          <v-text-field
            @keyup.enter="search"
            v-model="nick"
            dense
            light
            solo
            single-line
            hide-details
            color="grey darken-4 mx-2"
            placeholder="Nickname a analizar"
            maxlength="31"
            outlined
          ></v-text-field>
        </v-card>
      </v-col>

      <v-col cols="12" lg="4">
        <v-card class="pa-0 mx-2" outlined tile>
          <v-btn @click.stop="search" block depressed color="black" dark>Analizar</v-btn>
        </v-card>
      </v-col>
    </v-row>
    <template v-if="visualiza && userData">
      <!-- Linea 1 -->
      <v-row class="mb-6 seccion seccion-1" no-gutters>
        <v-col cols="12" lg="6">
          <v-card class="pa-2 mx-2" outlined tile height="200px">
            <v-toolbar flat dense>
              <v-toolbar-title>
                <span class="subheading">{{userData.full_name}}</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-list>
              <v-list-item three-line>
                <v-list-item-avatar size="80" color="grey">
                  <v-img :src="userData.profile_pic_url"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <div class="overline mb-4">{{ userData.username }}</div>
                  <v-list-item-subtitle>{{ userData.biography }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4" lg="2">
          <v-card class="pa-2 mx-2" outlined tile height="200px">
            <v-card-text
              class="subheading text-center"
              style="font-size: 1.15rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
            >Publicaciones</v-card-text>
            <v-card-text>
              <p
                class="display-1 text--primary text-center"
              >{{ userData.edge_owner_to_timeline_media.count.toLocaleString('de-DE') }}</p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4" lg="2">
          <v-card class="pa-2 mx-2" outlined tile height="200px">
            <v-card-text
              class="subheading text-center"
              style="font-size: 1.15rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
            >Seguidores</v-card-text>
            <v-card-text>
              <p
                class="display-1 text--primary text-center"
              >{{ userData.edge_followed_by.count.toLocaleString('de-DE') }}</p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4" lg="2">
          <v-card class="pa-2 mx-2" outlined tile height="200px">
            <v-card-text
              class="subheading text-center"
              style="font-size: 1.15rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
            >Siguiendo</v-card-text>
            <v-card-text>
              <p
                class="display-1 text--primary text-center"
              >{{ userData.edge_follow.count.toLocaleString('de-DE') }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <template v-if="!isPrivate">
        <!-- Linea 2 -->
        <v-row class="mb-6 seccion seccion-2" no-gutters>
          <v-col cols="12" lg="8">
            <v-card class="pa-2 mx-2 grafico" outlined tile height="300px">
              <GChart
                id="chartIe"
                @ready="onChartReady"
                :settings="{packages: ['corechart', 'bar'], language: 'es'}"
                type="ColumnChart"
                :data="chartData"
                :options="chartOptions"
              />
            </v-card>
          </v-col>

          <v-col cols="12" lg="4">
            <v-card class="pa-2 mx-2" outlined tile min-height="300px">
              <v-toolbar flat dense>
                <v-card-text
                  class="subheading text-center"
                  style="text-transform: uppercase;font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
                >Engagement</v-card-text>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <p
                  class="display-1 text--primary text-center"
                >{{ ieGlobal.toLocaleString('de-DE') }} %</p>
                <p
                  class="text-center"
                >El cálculo se ha realizado recogiendo la información de las últimas {{totalLastPost}} publicaciones</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Linea 3 -->
        <v-row class="mb-6 seccion seccion-3" no-gutters>
          <v-col cols="12" lg="4">
            <v-card class="pa-2 mx-2" outlined tile height="200px">
              <v-card-text
                class="subheading text-center"
                style="text-transform: uppercase;font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
              >Media de Likes</v-card-text>
              <v-card-text>
                <p
                  class="display-1 text--primary text-center"
                >{{ floatToString(mediaLikesAndComentCalc.mLikes, 1) }}</p>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="4">
            <v-card class="pa-2 mx-2" outlined tile height="200px">
              <!-- <v-toolbar flat dense>
                <v-toolbar-title>
                  <span class="subheading" style="text-transform: uppercase;">MEDIA DE COMENTARIOS</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>-->
              <v-card-text
                class="subheading text-center"
                style="text-transform: uppercase;font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
              >Media de Comentarios</v-card-text>
              <v-card-text>
                <p
                  class="display-1 text--primary text-center"
                >{{ floatToString(mediaLikesAndComentCalc.mComent, 1) }}</p>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="4">
            <v-card class="pa-2 mx-2" outlined tile min-height="200px">
              <v-card-text
                class="subheading text-center"
                style="text-transform: uppercase;font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
              >Frecuencia de Publicación</v-card-text>
              <v-card-text>
                <p
                  class="display-1 text--primary text-center"
                >{{ floatToString(frecuenciaPublicacion, 1) }} POST/DIA</p>
                <p
                  class="text-center"
                >El cálculo se ha realizado recogiendo la información de las últimas {{totalLastPost}} publicaciones</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Linea 4 -->
        <v-row class="mb-6 seccion seccion-3" no-gutters>
          <v-col cols="12" lg="6">
            <v-card class="pa-2 mx-2" outlined tile min-height="300px">
              <v-toolbar flat dense>
                <v-toolbar-title>
                  <span class="subheading">TOP 20 HASTAGS MÁS UTILIZADOS</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>{{counterHastags}}</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="6">
            <v-card class="pa-2 mx-2" outlined tile min-height="300px">
              <v-toolbar flat dense>
                <v-toolbar-title>
                  <span class="subheading">TOP 20 CUENTAS MÁS ETIQUETADAS</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-progress-linear v-if="!endEtiquetas" indeterminate color="cyan"></v-progress-linear>
              <v-card-text>{{counterEtiquetados}}</v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Linea 5 -->
        <v-row class="mb-6 seccion seccion-2" no-gutters>
          <v-col cols="12" lg="6">
            <v-card class="pa-2 mx-2 grafico" outlined tile height="300px">
              <GChart
                type="LineChart"
                :settings="{packages: ['corechart', 'line'], language:'es'}"
                :data="chartHorasData"
                :options="chartHorasOptions"
                :createChart="(el, google) => new google.charts.Line(el)"
                @ready="onChartReady"
              />
            </v-card>
          </v-col>

          <v-col cols="12" lg="6">
            <v-card class="pa-2 mx-2 grafico" outlined tile height="300px">
              <GChart
                type="BarChart"
                :settings="{packages: ['bar'], language:'es'}"
                :data="chartDiasData"
                :options="chartDiasOptions"
                :createChart="(el, google) => new google.charts.Bar(el)"
                @ready="onChartReady"
              />
            </v-card>
          </v-col>
        </v-row>

        <!-- Linea 6 -->
        <template v-if="$vuetify.breakpoint.lgOnly">
          <v-row class="mb-6 seccion seccion-4" no-gutters>
            <v-col cols="12">
              <v-card class="pa-2 mx-2" outlined tile>
                <v-row class="my-1" no-gutters>
                  <v-col cols="12" lg="7">
                    <v-card flat tile>
                      <v-toolbar flat dense>
                        <v-toolbar-title>
                          <span class="subheading">ÚLTIMOS {{totalLastPost}} POST PUBLICADOS</span>
                        </v-toolbar-title>
                      </v-toolbar>
                    </v-card>
                  </v-col>

                  <v-col cols="8" lg="2">
                    <v-card class="ml-3" elevation="0" tile>
                      <v-card-text
                        class="subheading text-center"
                        style="font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
                      >LIKES</v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="8" lg="2">
                    <v-card-text
                      class="subheading text-center"
                      style="font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
                    >COMENTARIOS</v-card-text>
                  </v-col>

                  <v-col cols="8" lg="1">
                    <v-card-text
                      class="subheading text-center"
                      style="font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;text-overflow: ellipsis;"
                    >IE</v-card-text>
                  </v-col>
                </v-row>

                <v-row class="my-1" no-gutters v-for="(item, i) in lastPost" :key="i">
                  <v-col cols="4" lg="1">
                    <v-card tile elevation="0" height="80">
                      <v-img width="80" :src="item.thumbnail"></v-img>
                    </v-card>
                  </v-col>

                  <v-col cols="8" lg="6">
                    <v-card tile elevation="0" height="80">
                      <v-card-text v-text="item.title"></v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="8" lg="2">
                    <v-card tile elevation="0" height="80">
                      <v-card-text class="text-center" v-text="item.likes"></v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="8" lg="2">
                    <v-card tile elevation="0" height="80">
                      <v-card-text class="text-center" v-text="item.comentarios"></v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="8" lg="1">
                    <v-card tile elevation="0" height="80">
                      <v-card-text class="text-center">{{ floatToString(item.ie, 2) }}%</v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row class="mb-1 seccion seccion-4" no-gutters v-for="(item, i) in lastPost" :key="i">
            <v-card class="mx-auto my-1">
              <v-img height="250" :src="item.thumbnail"></v-img>
              <v-card-text>
                <v-row align="center" class="mx-0">{{item.title}}</v-row>
              </v-card-text>
              <v-card-actions>
                <v-list-item class="grow">
                  <v-list-item-avatar color="grey darken-3">
                    <v-img
                      class="elevation-6"
                      :src="item.thumbnail"
                    ></v-img>
                  </v-list-item-avatar>

                  <v-row align="center" justify="end">
                    <v-icon class="mr-1">mdi-heart</v-icon>
                    <span class="subheading mr-2">{{item.likes}}</span>
                    <span class="mr-1">·</span>
                    <v-icon class="mr-1">mdi-comment</v-icon>
                    <span class="subheading mr-2">{{item.comentarios}}</span>
                    <span class="mr-1">·</span>
                    <v-icon class="mr-1">mdi-instagram</v-icon>
                    <span class="subheading">{{ floatToString(item.ie, 2) }}%</span>
                  </v-row>
                </v-list-item>
              </v-card-actions>
            </v-card>
          </v-row>
        </template>
      </template>
      <template v-else>
        <h3 class="subheading text-center">Esta cuenta es privada</h3>
      </template>
    </template>

    <template v-else>
      <Skeleton />
    </template>
  </v-container>
</template>

<script>
import { GChart } from "vue-google-charts";
import Skeleton from "./skeleton";
export default {
  props: ["userData", "cuentasEtiquetadas", "endEtiquetas", "error"],
  components: {
    GChart,
    Skeleton
  },
  data: () => ({
    nick: null,
    visualiza: false,
    meses: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ],
    chartsLib: null,
    chartHorasOptions: {
      chart: {
        title: "Horas de publicación",
        subtitle: ""
      },
      hAxis: {
        title: "Hora",
        suffix: " h."
      },
      vAxis: {
        title: "Publicaciones"
      },
      height: 250,
      legend: { position: "none" },
      colors: ["#ff1cc8"]
    },
    chartDataHeader: [
      { type: "datetime", label: "Fecha" },
      { type: "number", label: "IE" },
      { role: "style" }
    ],
    chartOptions: {
      maxItems: 50,
      language: "es",
      height: 250,
      legend: { position: "none" },
      bar: { groupWidth: "85%" },
      colors: ["#1E88E5", "#1E88E5"],
      hAxis: {
       viewWindowMode: 'pretty',
        // maxAlternation: 0,
        // showTextEvery: 2,
        // format: 'MM-y',
        // gridlines: {count: 3},
        // viewWindow: {
        //   min: new Date(2014, 11, 31, 23),
        //   max: new Date(2015, 0, 1, 1)
        // },
        gridlines: {
          count: 30,
          units: {
            days: { format: ["MMM dd"] },
            hours: { format: ["HH:mm", "ha"] }
          }
        },
        minorGridlines: {
          units: {
            hours: { format: ["hh:mm:ss a", "ha"] },
            minutes: { format: ["HH:mm a Z", ":mm"] }
          }
        },
        // viewWindow: {
        //   min: 0
        // },
        direction: 1,
        slantedText: true,
        slantedTextAngle: 45
      },
      chart: {
        title: "Engagement por post",
        subtitle: ""
      }
    },
    series: [
      {
        name: "Servings",
        data: [44, 55, 41, 67, 22, 43, 21, 33, 45, 31, 87, 65, 35]
      }
    ],
    apexChartOptions: {
      chart: {
        height: 250,
        type: "bar"
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
          endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 2
      },
      grid: {
        row: {
          colors: ["#fff", "#f2f2f2"]
        }
      },
      xaxis: {
        labels: {
          rotate: -45
        },
        categories: [
          "Apples",
          "Oranges",
          "Strawberries",
          "Pineapples",
          "Mangoes",
          "Bananas",
          "Blackberries",
          "Pears",
          "Watermelons",
          "Cherries",
          "Pomegranates",
          "Tangerines",
          "Papayas"
        ],
        tickPlacement: "on"
      },
      yaxis: {
        title: {
          text: "Servings"
        }
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 0.85,
          opacityTo: 0.85,
          stops: [50, 0, 100]
        }
      }
    }
  }),

  watch: {
    lastPost() {
      this.visualiza = true;
    }
  },

  computed: {
    hastags() {
      return this.conteoHasTags();
    },

    ieGlobal() {
      // Formula: me gusta + comentarios dividido por el número de seguidores de esa cuenta y multiplicado por mil
      let result = 0;
      let sum = 0;
      if (this.lastPost && this.lastPost.length > 0) {
        this.lastPost.forEach(p => {
          sum += p.ie;
        });
        result = sum / this.lastPost.length;
      }
      return this.numeroToDec(result, 2);
    },

    frecuenciaPublicacion() {
      // Formula: Cada cuantos dias de media pública.  cuantos dias de diferencia hay entre publicaciones/número de publicaciones
      let result = `0.00`;

      if (this.lastPost && this.lastPost.length > 1) {
        let sumaDias = 0;
        for (let index = 1; index < this.lastPost.length; index++) {
          const inicio = this.lastPost[index];
          const fin = this.lastPost[index - 1];
          const fechaInicio = inicio.timestamp * 1000;
          const fechaFin = fin.timestamp * 1000;
          const diff = Math.abs(fechaInicio - fechaFin);
          sumaDias += diff / (1000 * 60 * 60 * 24);
        }
        result = this.lastPost.length / sumaDias;
      }
      return result;
    },

    diasHorasPublicacion() {
      // Formula: Suma de publicaciones en cada hora (0-23) y día (L-D)
      let horas = [];
      for (let index = 0; index < 24; index++) {
        horas[index] = this.lastPost
          ? this.lastPost.filter(p => p.horaDia === index).length
          : 0;
      }
      let dias = [];
      for (let index = 0; index < 7; index++) {
        dias[index] = this.lastPost
          ? this.lastPost.filter(p => p.diaSemana === index).length
          : 0;
      }
      const result = {
        horas: horas,
        dias: dias
      };
      return result;
    },

    frecuenciaPublicacion_old() {
      // Formula cuantos dias de diferencia hay entre publicaciones/número de publicaciones
      let result = `0.00`;
      if (this.lastPost && this.lastPost.length > 0) {
        const fechaInicio = new Date().getTime(); // this.lastPost[0].timestamp * 1000; // 1582286551
        const fechaFin =
          this.lastPost[this.lastPost.length - 1].timestamp * 1000; // 1569919713
        const diff = fechaInicio - fechaFin;
        const dias = diff / (1000 * 60 * 60 * 24);
        result = this.lastPost.length / dias;
      }
      return result;
    },

    counterHastags() {
      let result = "";
      if (this.hastags && this.lastPost.length > 0) {
        this.hastags.slice(0, 20).forEach(h => {
          result += `${h.tag} (${h.count}) `;
        });
      }
      return result.trim();
    },

    counterEtiquetados() {
      return this.conteoEtiquetados();
    },

    chartData() {
      return [this.chartDataHeader, ...this.chartDataDatos];
    },

    chartDataDatos() {
      let meses = [];
      const colors = ["#215F80", "#8FD8FF", "#42BDFF", "#476C80", "#3597CC"];
      const maxIndexColors = colors.length - 1;

      let result = [];
      let datos = this.lastPost ? this.lastPost.slice() : null;
      if (datos && this.lastPost.length > 0) {
        datos = datos.slice(0, this.chartOptions.maxItems);
        datos = this.ordenaResultados(datos, -1);
        datos.forEach(element => {
          // Color
          const fecha = new Date(element.timestamp * 1000);
          const mes = fecha.getMonth();
          let coincide = meses.indexOf(mes);
          if (coincide < 0) {
            coincide = meses.length;
            meses.push(mes);
          }
          const idx = this.maxIndexColor(coincide, maxIndexColors);
          const color = colors[idx];

          result.push([fecha, element.ie, color]);
        });
      }
      return result;
    },

    chartHorasData() {
      let result = [["", ""]];
      let idx = 0;
      const datos =
        this.diasHorasPublicacion && this.diasHorasPublicacion.horas
          ? this.diasHorasPublicacion.horas.slice()
          : null;
      if (datos && datos.length > 0) {
        datos.forEach(e => {
          result.push([`${idx}`, e]);
          idx++;
        });
      }
      return result;
    },

    chartDiasData() {
      let result = [["", ""]];
      const datos =
        this.diasHorasPublicacion && this.diasHorasPublicacion.dias
          ? this.diasHorasPublicacion.dias.slice()
          : null;
      if (datos && datos.length > 0) {
        result.push(["Lunes", datos[1]]);
        result.push(["Martes", datos[2]]);
        result.push(["Miércoles", datos[3]]);
        result.push(["Jueves", datos[4]]);
        result.push(["Viernes", datos[5]]);
        result.push(["Sábado", datos[6]]);
        result.push(["Domingo", datos[0]]);
      }
      return result;
    },

    totalLastPost() {
      return this.lastPost.length || 0;
    },

    isPrivate() {
      let result = false;
      if (this.userData && this.userData.is_private) {
        result = true;
      }
      return result;
    },

    lastPost() {
      let result = [];
      // Vídeos
      let resource = this.userData
        ? this.userData.edge_felix_video_timeline.edges
        : null;

      let agregar = this.extraeData(resource);
      if (agregar) {
        agregar.forEach(element => {
          result.push(element);
        });
      }

      // Fotos
      resource = this.userData
        ? this.userData.edge_owner_to_timeline_media.edges
        : null;

      agregar = this.extraeData(resource);
      if (agregar) {
        agregar.forEach(element => {
          result.push(element);
        });
      }

      // return this.ordenaResultados(result, 1);
      return this.ordenaResultados(result, 1, "timestamp", 50);
    },

    chartOptions_back() {
      if (!this.chartsLib) return null;
      return this.chartsLib.charts.Bar.convertOptions({
        chart: {
          title: "Engagement por post",
          subtitle: ""
        },
        bars: "vertical", // Required for Material Bar Charts.
        hAxis: {
          viewWindow: {
            min: 0
          },
          direction: -1,
          slantedText: true,
          slantedTextAngle: 90
        },
        height: 250,
        legend: { position: "none" },
        bar: { groupWidth: "75%" },
        colors: ["#1E88E5", "#1E88E5"],
        theme: "material"
      });
    },

    chartHorasOptions_old() {
      if (!this.chartsLib) return null;
      return this.chartsLib.charts.Line.convertOptions({
        chart: {
          title: "Horas de publicación",
          subtitle: ""
        },
        hAxis: {
          title: "Hora",
          suffix: " h."
        },
        vAxis: {
          title: "Publicaciones"
        },
        height: 200,
        legend: { position: "none" },
        colors: ["#ff1cc8"]
      });
    },

    chartDiasOptions() {
      if (!this.chartsLib) return null;
      return this.chartsLib.charts.Bar.convertOptions({
        chart: {
          title: "Días de publicación",
          subtitle: ""
        },
        bars: "horizontal", // Required for Material Bar Charts.
        height: 250,
        legend: { position: "none" },
        bar: { groupWidth: "75%" },
        colors: ["#ed4956"]
      });
    },

    mediaLikesAndComentCalc() {
      // Formula: Es la media de likes de todos los post recogidos
      let result = {
        mLikes: 0,
        mComent: 0
      };
      if (this.userData) {
        const totalPost = this.totalLastPost || false;
        if (totalPost) {
          let sumaLikes = 0;
          let sumaComent = 0;
          this.lastPost.forEach(e => {
            sumaLikes += e.likes;
            sumaComent += e.comentarios;
          });
          result.mLikes = this.numeroToDec(sumaLikes / totalPost);
          result.mComent = this.numeroToDec(sumaComent / totalPost);
        }
      }
      return result;
    }
  },

  methods: {
    quitaNumerosGrafico() {
      const svg = document.getElementById('chartIe');
      const txts = svg.getElementsByTagName('text');
      for (let index = 0; index < txts.length; index++) {
        const element = txts[index];
        const val = parseInt(element.innerHTML)
        if (val) {
          element.innerHTML = ''
        }
      }
    },

    maxIndexColor(idx, maxIndexColors) {
      // devuelve el valor idx correcto dentro del rango [0 - maxIndexColors]
      if (idx <= maxIndexColors) {
        return idx;
      }
      return idx % maxIndexColors
        ? idx - Math.floor(idx / maxIndexColors) * maxIndexColors - 1
        : maxIndexColors;
    },

    search() {
      const name = this.nick;
      this.$emit("analizar", name);
    },

    conteoHasTags() {
      let result = [];
      let encontrados = [];
      if (this.lastPost && this.lastPost.length > 0) {
        this.lastPost.forEach(element => {
          element.hastags.forEach(t => {
            const idx = encontrados.indexOf(t);
            if (idx < 0) {
              result.push({
                tag: t,
                count: 1
              });
              encontrados.push(t);
            } else {
              result[idx].count++;
            }
          });
        });
      }
      return this.ordenaResultados(result, 1, "count");
    },

    conteoEtiquetados() {
      let result = "";
      if (this.cuentasEtiquetadas && this.cuentasEtiquetadas.length > 0) {
        let encontrados = [];
        let parcial = [];
        this.cuentasEtiquetadas.forEach(e => {
          const t = e.node.user.username;
          const idx = encontrados.indexOf(t);
          if (idx < 0) {
            parcial.push({
              cuenta: t,
              count: 1
            });
            encontrados.push(t);
          } else {
            parcial[idx].count++;
          }
        });
        parcial = this.ordenaResultados(parcial, 1, "count");
        parcial.slice(0, 20).forEach(h => {
          result += `@${h.cuenta} (${h.count}) `;
        });
      }
      return result.trim();
    },

    scanPost() {
      let result = [];
      // Vídeos
      let resource =
        this.userData && this.userData.edge_felix_video_timeline.edges.count > 0
          ? this.userData.edge_felix_video_timeline.edges
          : null;

      let agregar = this.extraeData(resource);
      if (agregar) {
        agregar.forEach(element => {
          result.push(element);
        });
      }

      // Fotos
      resource =
        this.userData &&
        this.userData.edge_owner_to_timeline_media.edges.count > 0
          ? this.userData.edge_owner_to_timeline_media.edges
          : null;

      agregar = this.extraeData(resource);
      if (agregar) {
        agregar.forEach(element => {
          result.push(element);
        });
      }

      this.lastPost = this.ordenaResultados(result, 1);
      this.conteoHasTags();
    },

    numeroToDec(n, dec = 2) {
      /**
       * retorna el número 'n' con un máximo de decimales definidos por 'dec'
       */
      if (!n || Number.isNaN(parseFloat(n))) {
        return 0;
      }
      const e = Math.pow(10, dec);
      return Math.round(parseFloat(n) * e) / e;
    },

    floatToString(n, dec, separador = ",") {
      /**
       * retorna el número 'n' como un string forzando el número de decimales definidos por 'dec'
       */
      if (!n || Number.isNaN(parseFloat(n))) {
        return `0${separador}00`;
      }
      const e = Math.pow(10, dec);
      const int = parseInt(n);
      const d = `${parseInt((n - int) * e)}0000000000`.slice(0, dec);
      return `${int}${separador}${d}`;
    },

    extraeData(resource) {
      // I.E. Formula: me gusta + comentarios dividido por el número de seguidores de esa cuenta y multiplicado por mil
      let result = [];
      if (!resource || resource.length < 1) {
        return null;
      }
      resource.forEach(element => {
        const node = element.node;
        const comentarios = node.edge_media_to_comment.count;
        const likes = node.edge_media_preview_like.count;
        const thumbnail = node.thumbnail_src;
        const fecha = new Date(node.taken_at_timestamp * 1000);
        const fComposer = `${
          this.meses[fecha.getMonth()]
        } ${fecha.getFullYear()}`;

        let txt = "";
        node.edge_media_to_caption.edges.forEach(item => {
          txt += item.node.text;
        });

        const has_tags = txt.split("#");
        let hastags = [];
        for (let index = 1; index < has_tags.length; index++) {
          let e = has_tags[index].trim();
          e = e.split(" ")[0];
          hastags.push(`#${e}`);
        }
        const text = txt.slice(0, 150);

        result.push({
          shortcode: node.shortcode,
          isVideo: node.is_video,
          comentarios: comentarios,
          likes: likes,
          thumbnail: thumbnail,
          title: text,
          timestamp: node.taken_at_timestamp,
          diaSemana: new Date(node.taken_at_timestamp * 1000).getDay(),
          horaDia: new Date(node.taken_at_timestamp * 1000).getHours(),
          fComposer: fComposer,
          ie: this.ieCalc(likes, comentarios),
          hastags: hastags
        });
      });
      return result;
    },

    ordenaResultados(items, order = 1, campo = "timestamp", limit = null) {
      items.sort(function(b, a) {
        if (a[campo] > b[campo]) {
          return order;
        }
        if (a[campo] < b[campo]) {
          return -1 * order;
        }
        return 0;
      });
      if (limit && typeof limit === "number") {
        return items.slice(0, limit);
      }
      return items;
    },

    ieCalc(likes, comments) {
      /**
       * 101 me gusta + 18 comentario =119/ 1728 (seguidores) = 0,0688 x 1000 = 68,86
       * basado en: https://metricool.com/es/que-es-el-engagement-en-instagram-y-como-puede-ayudarte/
       * // Formula: me gusta + comentarios dividido por el número de seguidores de esa cuenta y multiplicado por mil
       */
      const totalSeguidores = this.userData.edge_followed_by.count;
      const result = (((likes + comments) / totalSeguidores) * 1000) / 10;
      return this.numeroToDec(result, 2);
    },

    mediaLikesAndComentCalcMetodo() {
      // Formula: Es la media de likes de todos los post recogidos
      let result = {
        mLikes: 0,
        mComent: 0
      };
      const totalPost = this.totalLastPost || false;
      if (totalPost) {
        let sumaLikes = 0;
        let sumaComent = 0;
        this.lastPost.forEach(e => {
          sumaLikes += e.likes;
          sumaComent += e.comentarios;
        });
        result.mLikes = this.numeroToDec(sumaLikes / totalPost);
        result.mComent = this.numeroToDec(sumaComent / totalPost);
      }

      return result;
    },

    onChartReady(chart, google) {
      this.chartsLib = google;
      this.quitaNumerosGrafico();
    }
  }
};
</script>
